import { Component, inject, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { CommonUtils } from '../../../../common/common-utils';
import { LanguageTranslationState } from '../../../../../shared/models/dtc/language-translation-state';
import { TranslationLanguageStatistics } from './translation-language-statistics';
import { TranslationStateStatistics } from './translation-state-statistics';
import { NgClass } from '@angular/common';
import { AppInsightsService } from '../../../../services/app-insights.service';
import { ShareCalculator } from './share-calculator';

@Component({
  selector: 'app-translation-state',
  imports: [NgClass],
  templateUrl: './translation-state.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './translation-state.component.scss',
})
export class TranslationStateComponent implements OnChanges, OnInit {
  @Input() public translationStates?: LanguageTranslationState[];

  public translationStatistics: TranslationLanguageStatistics[] = [];
  public commonUtils = CommonUtils;

  private appInsightsService = inject(AppInsightsService);

  public ngOnInit(): void {
    this.appInsightsService.logSidebarUsage('TranslationState');
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['translationStates']) {
      const states = changes['translationStates'].currentValue as LanguageTranslationState[];
      if (!states) {
        this.translationStatistics = [];
        return;
      }

      const shareCalculator = new ShareCalculator();
      const groupedData = new Map<string, TranslationLanguageStatistics>();
      states.forEach((i) => {
        const langCode = i.languageCode || 'unknown';
        const langStats =
          groupedData.get(langCode) ??
          ({
            languageCode: langCode,
            total: 0,
            states: [],
          } as TranslationLanguageStatistics);
        langStats.total += i.count;
        langStats.states.push({
          translationState: i.translationState,
          count: i.count,
          percent: 0,
        } as TranslationStateStatistics);

        shareCalculator.RecalculateShares(langStats.total, langStats.states);
        shareCalculator.RecalculateSmallShares(langStats.states);

        langStats.states = langStats.states.sort((a, b) => {
          if (
            (CommonUtils.translationStateDisplayConfig.get(a.translationState)?.displayOrder ?? 200) <
            (CommonUtils.translationStateDisplayConfig.get(b.translationState)?.displayOrder ?? 200)
          ) {
            return -1;
          }
          if (
            (CommonUtils.translationStateDisplayConfig.get(a.translationState)?.displayOrder ?? 200) >
            (CommonUtils.translationStateDisplayConfig.get(b.translationState)?.displayOrder ?? 200)
          ) {
            return 1;
          }
          return 0;
        });

        groupedData.set(langCode, langStats);
      });

      this.translationStatistics = Array.from(groupedData.values()).sort((a, b) => {
        if (a.languageCode < b.languageCode) {
          return -1;
        }
        if (a.languageCode > b.languageCode) {
          return 1;
        }
        return 0;
      });
    }
  }
}
